/* shouye daojishi js */
window.timeZoneParams = -7;
    /* getLocalTime:时区换算*/
    window.getLocalTime = function (i) {
        // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        var d = new Date();
        //得到1970年一月一日到现在的秒数
        var len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        var offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }
    /*end getLocalTime:时区换算*/
    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }


    $(function () {
        if ($(".memberFlash-timeBox").length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + "/" + date_month + "/" + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;
            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; //鏃堕棿榛樿鍊�
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
                if (!$(".hl .item").eq(hourInt).hasClass("active")) {
                    $(".hl .item.before").removeClass("before");
                    $(".hl .item").eq(int1).addClass("before");
                    $(".hl .item.active").removeClass("active");
                    $(".hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".hr .item").eq(hourDot).hasClass("active")) {
                    $(".hr .item.before").removeClass("before");
                    $(".hr .item").eq(int2).addClass("before");
                    $(".hr .item.active").removeClass("active");
                    $(".hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".ml .item").eq(minuteInt).hasClass("active")) {
                    $(".ml .item.active").removeClass("active");
                    $(".ml .item").eq(minuteInt).addClass("active");
                    $(".ml .item.before").removeClass("before");
                    $(".ml .item").eq(int3).addClass("before");
                }

                if (!$(".mr .item").eq(minuteDot).hasClass("active")) {
                    $(".mr .item.active").removeClass("active");
                    $(".mr .item").eq(minuteDot).addClass("active");
                    $(".mr .item.before").removeClass("before");
                    $(".mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".sl .item").eq(secondInt).hasClass("active")) {
                    $(".sl .item.active").removeClass("active");
                    $(".sl .item").eq(secondInt).addClass("active");
                    $(".sl .item.before").removeClass("before");
                    $(".sl .item").eq(int5).addClass("before");
                }

                if (!$(".sr .item").eq(secondDot).hasClass("active")) {
                    $(".sr .item.active").removeClass("active");
                    $(".sr .item").eq(secondDot).addClass("active");
                    $(".sr .item.before").removeClass("before");
                    $(".sr .item").eq(int6).addClass("before");
                }
            }
            var groupTime = setInterval(function () {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth() + 1;
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + "/" + date_month + "/" + date_day,1);
                    endAllTime = new Date(endTime).getTime() - date;
                    if (typeof every_flash_enable != "undefined" && every_flash_enable == '1') {
                        homeFlash();
                    }
                }
            }, 1000);
        }


      // 首页类目切换
      $(".home-recommend_head").each(function () {
            $(this).find(".home-recommend_btn:eq(0)").addClass("active");
            var $proTilBox = $(this).closest('.recomtitle').siblings(".home-recommend_proBox");
            $proTilBox.find('.recommend_pro-list:eq(0)').css('display', 'block');
      });
      $(".home-recommend_head .home-recommend_btn").click(function(){
          $(this).addClass("active").siblings().removeClass("active");
          var clickindex = $(this).index();
          $(this).closest('.recomtitle').siblings(".home-recommend_proBox").find('.recommend_pro-list').hide().eq($(this).index()).show();
      })
      
    })




// 新版倒计时
    function getLocalTime(i) {
        if (typeof i !== 'number') return;
        var d = new Date();
        var len = d.getTime();
        var offset = d.getTimezoneOffset() * 60000;
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }

    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        console.log(dd)
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }
    var timeZoneParams = -7;
    jQuery(function() {
        if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;

            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0;
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor(intDiff / 1000 / 60 % 60);
                    second = Math.floor(intDiff / 1000 % 60);
                }
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }

                jQuery('.flashSale-clock_timeH').text(hour);
                jQuery('.flashSale-clock_timeM').text(minute);
                jQuery('.flashSale-clock_timeS').text(second);
                // 时
                var str1 = hour + '';
                var s1 = str1.substr(0, 1);
                jQuery('.memberFlash-time_timeH_one').text(s1);
                jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
                // 分
                var str2=minute + '';
                var s2=str2.substr(0, 1);
                jQuery('.memberFlash-time_timeM_one').text(s2);
                jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
                // 秒
                var str3=second + '';
                var s3=str3.substr(0, 1);
                jQuery('.memberFlash-time_timeS_one').text(s3);
                jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
            }
            var groupTime = setInterval(function() {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth();
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                    endAllTime = new Date(endTime).getTime() - date;
                }
            }, 1000);
        }

    })
    // 倒计时结束

// 详情页code
 function copyToClipboard(str) {
      let el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      let selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    }
    function copyCode(e) {
      let $this = e.target;
      copyToClipboard($this.getAttribute("data-code"));
      $this.innerText = "copied!";
      setTimeout(function () {
        $this.innerText = "copy";
      }, 1500);
    }



var mySwiper_featured_lunbo = new Swiper('.hu-featured-lunbo', {
            slidesPerView : 4.6,
            spaceBetween : 15,
            breakpoints: {
              768: {
      			slidesPerView:1.8,
      			spaceBetween: 0,
      			},
            },
            navigation: {
              nextEl: '.left_ri_niu .swiper-button-next',
              prevEl: '.left_ri_niu .swiper-button-prev',
            },
        });

var mySwiper_ollection_products = new Swiper('.hu-collection-products', {
            slidesPerView : 3.5,
            spaceBetween : 15,
             navigation: {
              nextEl: '.hu-products-page .swiper-button-next',
              prevEl: '.hu-products-page .swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:2.1,
            spaceBetween: 15,
              },
            },
           
          scrollbar: {
              el: ".hu-products-page .swiper-scrollbar",
           },
        });


var mySwiper_ollection_productstwo = new Swiper('.hu-collection-products-two', {
            slidesPerView : 5,
            spaceBetween : 15,
            navigation: {
              nextEl: '.hu-products-page-two .swiper-button-next',
              prevEl: '.hu-products-page-two .swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:2.1,
            spaceBetween: 15,
              },
            },
           
          scrollbar: {
              el: ".hu-products-page-two .swiper-scrollbar",
           },
        });

var concerns_hea = new Swiper('.concerns-hea', {
            slidesPerView : 4.5,
            spaceBetween : 15,
            breakpoints: {
              768: {
            slidesPerView:1.5,
            spaceBetween: 15,
              },
            },
        });

var double_product = new Swiper('.double-product-ttop', {
            slidesPerView : 4.2,
            spaceBetween : 15,
            breakpoints: {
              768: {
            slidesPerView:2,
            spaceBetween: 15,
              },
            },
        });




var mySwiper_ollection_productstwo = new Swiper('.hu-reviews-lunbo', {
            slidesPerView : 3.5,
            spaceBetween : 1,
            navigation: {
              nextEl: '.hu_reviews .swiper-button-next',
              prevEl: '.hu_reviews .swiper-button-prev',
            },
            breakpoints: {
              768: {
                  slidesPerView:2.2,
                  spaceBetween: 3,
              },
            },
        });

// 购物车订单备注
jQuery(function(){
  jQuery('.cart-note .block-note+svg').on('click', function(){
      jQuery('.cart-note #note').toggle();
  });
})
  // 首页视频模块点击播放
  window.addEventListener('DOMContentLoaded', function() {
      $('.grid__item-video').on('click', function(){
          var index = $(this).index();
          $(this).find('.image-element').removeClass('hidden').addClass('hidden');
          $(this).find('.element-svg').removeClass('hidden').addClass('hidden');
          $(this).find('.tex-im-video').removeClass('active').addClass('active')
      });
  });

$('ul.tab-list li').click(function(event){
  event.preventDefault();
  var tab_id = $(this).attr('data-tab');
  $('ul.tab-list li').removeClass('current');
  $('.tab-content').removeClass('current');
  $(this).addClass('current');
  $("#"+tab_id).addClass('current');
})


// 一键跳到顶部
$(window).scroll(function() {
    var backToTopBtn = $('#backToTopBtn');
    if ($(window).scrollTop() > 200) { 
        backToTopBtn.fadeIn();
    } else { 
        backToTopBtn.fadeOut();
    }
});


$('#backToTopBtn').click(function() {
    $('html, body').animate({
        scrollTop: 0
    }, 500, function() {
        $('#backToTopBtn').fadeOut(); // 跳到顶部后隐藏按钮
    });
});










